import React from 'react';
const modules = [{
  num: 1,
  title: 'Mentalidad y Posicionamiento Digital',
  subtitle: 'La base que nadie te cuenta antes de publicar',
  desc: 'Entendé por qué las redes no te traen clientes todavía y cómo cambiar eso en 7 días optimizando tu perfil y tu mensaje.',
  bullets: ['Los 5 errores que frenan tus ventas en redes', 'Plantilla de posicionamiento: qué vendés, a quién y por qué', 'Checklist completo para optimizar tu perfil en IG y FB']
}, {
  num: 2,
  title: 'Conocé a tu Cliente Ideal',
  subtitle: 'Hablale exactamente a quien te va a comprar',
  desc: 'Identificá a tu comprador ideal, entendé qué le duele y aprendé a hablarle con sus propias palabras.',
  bullets: ['Ficha completable de buyer persona con ejemplos argentinos', 'Cómo encontrar el lenguaje exacto de tu cliente', 'Cómo adaptar el mensaje para Instagram y para Facebook']
}, {
  num: 3,
  title: 'Contenido que Vende sin Vender',
  subtitle: 'El sistema de 3 pilares que convierte seguidores',
  desc: 'El método que usan las cuentas que más venden: contenido educativo, entretenimiento y conversión en la proporción exacta.',
  bullets: ['Calendario de contenido mensual listo para completar', 'Formatos que funcionan en IG y en FB según el objetivo', 'Ejemplos reales para rubros argentinos variados']
}, {
  num: 4,
  title: 'El Arte de Captar Atención',
  subtitle: 'Hacé que paren de scrollear en 3 segundos',
  desc: 'Copywriting, hooks y diseño visual para que tu contenido se destaque.',
  bullets: ['Estructura AIDA para captions que venden', 'Guión para reels y videos cortos de 15, 30 y 60 segundos', 'Secuencia de 4 stories para presentar y cerrar una venta']
}, {
  num: 5,
  title: 'Publicidad Paga sin Desperdiciar Plata',
  subtitle: 'Meta Ads desde cero con presupuesto pequeño',
  desc: 'Cómo crear campañas en Meta Ads que realmente funcionen, cuánto invertir y cómo saber si tu plata está bien gastada.',
  bullets: ['Segmentación para Argentina: intereses, edad y ubicación', 'Test A/B: cómo saber qué anuncio funciona y cuál apagar', 'Las 4 métricas que importan (y las que solo distraen)']
}, {
  num: 6,
  title: 'Del Seguidor al Comprador',
  subtitle: 'Convertí la atención en ventas reales',
  desc: 'El embudo completo: desde que alguien te descubre hasta que te compra.',
  bullets: ['Scripts listos para responder "¿cuánto sale?" y cerrar la venta', 'Cómo responder "está caro" sin bajar el precio', 'Estrategia de fidelización para que vuelvan a comprarte']
}];
export function Modules() {
  return <section id="modules" className="py-20 bg-white px-4" data-id="element-188">
      <div className="max-w-6xl mx-auto" data-id="element-189">
        <div className="text-center mb-16" data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-191">
            Las 6 guías — Tu hoja de ruta para vender en redes
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto" data-id="element-192">
            Cada guía tiene mínimo 20 páginas de contenido aplicable. No teoría:
            ejercicios, plantillas y herramientas que usás el mismo día que las
            leés.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-193">
          {modules.map(mod => <div key={mod.num} className="bg-white rounded-2xl p-8 shadow-lg border border-slate-100 relative pt-12" data-id="element-194">
              <div className="absolute -top-6 left-8 w-12 h-12 bg-sky text-navy font-bold text-xl rounded-full flex items-center justify-center shadow-md" data-id="element-195">
                {mod.num}
              </div>

              <h3 className="text-xl font-bold text-navy mb-2" data-id="element-196">{mod.title}</h3>
              <p className="text-sky-hover font-medium text-sm mb-4" data-id="element-197">
                {mod.subtitle}
              </p>
              <p className="text-slate-600 text-sm mb-6" data-id="element-198">{mod.desc}</p>

              <ul className="space-y-3" data-id="element-199">
                {mod.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-200">
                    <span className="text-sky mt-0.5" data-id="element-201">•</span>
                    <span data-id="element-202">{bullet}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}